'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _support = require('helpers/support');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const maxLines = 2;
var MyVoucherItem = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(MyVoucherItem, _Component);

  function MyVoucherItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MyVoucherItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MyVoucherItem.__proto__ || (0, _getPrototypeOf2.default)(MyVoucherItem)).call.apply(_ref, [this].concat(args))), _this), _this.onErrorImage = function (event) {
      event.target.onerror = null;
      event.target.src = '/error-img.svg';
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MyVoucherItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          item = _props.item,
          onBooking = _props.onBooking,
          onPress = _props.onPress,
          style = _props.style;
      var countDown = item.countDown,
          title = item.title,
          image = item.image,
          newPrice = item.newPrice,
          oldPrice = item.oldPrice,
          isUsed = item.isUsed,
          code = item.code,
          isBooking = item.isBooking;

      var styles = require('./MyVoucherItem.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.container + ' ' + style, onClick: onPress },
        _react2.default.createElement(
          'div',
          { className: styles.expireView },
          _react2.default.createElement(
            'div',
            { className: styles.expireText },
            countDown,
            ' ng\xE0y'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.imageContainer },
          _react2.default.createElement('img', { src: image, onError: this.onErrorImage })
        ),
        _react2.default.createElement('div', { className: styles.verticalDashes }),
        _react2.default.createElement(
          'div',
          { className: styles.voucherInfoContainer },
          _react2.default.createElement(
            'span',
            { className: styles.voucherTitle },
            title
          ),
          _react2.default.createElement(
            'div',
            { className: styles.priceView },
            _react2.default.createElement(
              'div',
              { className: styles.priceInfo },
              _react2.default.createElement(
                'span',
                { className: styles.newPrice },
                _support.Helper.formatMoney(newPrice)
              ),
              _react2.default.createElement(
                'span',
                { className: styles.oldPrice },
                _support.Helper.formatMoney(oldPrice)
              )
            ),
            !!(isBooking && !isUsed) && _react2.default.createElement(
              'span',
              { className: styles.bookingBtn, onClick: onBooking },
              '\u0110\u1EB7t l\u1ECBch'
            ),
            !isBooking && _react2.default.createElement(
              'span',
              { className: styles.userCode },
              code
            )
          )
        )
      );
    }
  }]);
  return MyVoucherItem;
}(_react.Component), _class.propTypes = {
  item: _react.PropTypes.object,
  style: _react.PropTypes.string,
  onBooking: _react.PropTypes.func,
  onPress: _react.PropTypes.func
}, _temp2);
exports.default = MyVoucherItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Reward/MyVoucherItem.js
// module id = 1629
// module chunks = 0